<div *ngIf="containerDisplay==='LIST'">
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th colspan="2" class="center">Add Player to field</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                        <td colspan="2">
                            <div class="checkbox-list">
                                <label class="checkbox-item" *ngFor="let p of players">
                                    <input
                                    type="checkbox"
                                    [(ngModel)]="p.isSelected"
                                    name="player-{{ p.obj.id }}"
                                    />
                                    <span class="checkbox-label">
                                    {{ p.obj.firstName }} {{ p.obj.lastName }}
                                    </span>
                                </label>
                            </div>
                            <button (click)="containerDisplay = 'NEWPLAYER'" class="tiny">Create New Player</button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button (click)="addPlayersToField()">Add Selected Players to Field</button>
                        </td>
                    </tr>
            </tbody>
        </table>
    </div>
</div>

<app-add-edit-player (saved)="newPlayerCreated($event)" (canceled)="containerDisplay = 'LIST'" *ngIf="containerDisplay==='NEWPLAYER'" [saveButtonText]="'Create Player'" [title]="'Add New Player'"></app-add-edit-player>
